<template>
  <PmwModal v-model="showModal" width="1175px">
    <!-- TEMPLATE DO CABEÇALHO -->
    <template #header-content>
      <div class="pmw-modal--title">
        <PmwHeading size="heading-80" element="h2">
          Histórico
        </PmwHeading>
        <PmwParagraph weight="normal" class="pmw-modal--description">
          <b>Criado por</b> Jessica Oliveira, 12/04/2019 |
          <b>Última alteração</b> por Gabriela Silveira, 21/08/2020
        </PmwParagraph>
      </div>
    </template>

    <!-- TEMPLATE DA TABELA -->
    <template>
      <DataTable
        :cols="cols"
        :rows="rows"
        :isLoading="false"
        :colsMinWidths="minWidths"
        :noFrames="true"
        class="pmw-modal--datatable"
      />
    </template>
  </PmwModal>
</template>

<script>
import PmwModal from '@solucoes/components-lib-tmp/src/components/patterns/PmwModal'
import DataTable from '@solucoes/components-lib-tmp/src/components/patterns/DataTable'
import PmwHeading from '@solucoes/components-lib-tmp/src/components/elements/PmwHeading'
import PmwParagraph from '@solucoes/components-lib-tmp/src/components/elements/PmwParagraph'

export default {
  name: 'HistoryModal',

  components: {
    PmwModal,
    PmwHeading,
    PmwParagraph,
    DataTable
  },

  props: {
    showModal: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      minWidths: {
        date: '155px',
        user: '155px',
        info: '250px',
        oldValue: '100px',
        newValue: '100px'
      },
      cols: [
        {
          alias: 'Data/Hore',
          name: 'date'
        },
        {
          alias: 'Usuário',
          name: 'user'
        },
        {
          alias: 'Informações',
          name: 'info'
        },
        {
          alias: 'Valor anterior',
          name: 'oldValue'
        },
        {
          alias: 'Valor novo',
          name: 'newValue'
        }
      ],
      rows: [
        {
          data: {
            date: '14/04/2020 18:42',
            user: 'Gabriela Silveira',
            info: 'Removida pensão Adultos.',
            oldValue: '',
            newValue: ''
          }
        },
        {
          data: {
            date: '14/04/2020 18:42',
            user: 'Gabriela Silveira',
            info: 'Removida pensão CRIANÇAS - 0 A 5 ANOS.',
            oldValue: '',
            newValue: ''
          }
        },
        {
          data: {
            date: '14/04/2020 18:42',
            user: 'Gabriela Silveira',
            info: 'Removida pensão CRIANÇAS - 6 A 12 ANOS.',
            oldValue: '',
            newValue: ''
          }
        },
        {
          data: {
            date: '14/04/2020 18:42',
            user: 'Gabriela Silveira',
            info: 'Removida pensão CRIANÇAS - 13 A 15 ANOS.',
            oldValue: '',
            newValue: ''
          }
        },
        {
          data: {
            date: '14/04/2020 18:42',
            user: 'Gabriela Silveira',
            info: 'Removida pensão CRIANÇAS - 13 A 15 ANOS.',
            oldValue: '',
            newValue: ''
          }
        },
        {
          data: {
            date: '14/04/2020 18:42',
            user: 'Gabriela Silveira',
            info: 'Removida pensão CRIANÇAS - 13 A 15 ANOS.',
            oldValue: '',
            newValue: ''
          }
        },
        {
          data: {
            date: '14/04/2020 18:42',
            user: 'Gabriela Silveira',
            info: 'Removida pensão CRIANÇAS - 13 A 15 ANOS.',
            oldValue: '',
            newValue: ''
          }
        },
        {
          data: {
            date: '14/04/2020 18:42',
            user: 'Gabriela Silveira',
            info: 'Removida pensão CRIANÇAS - 13 A 15 ANOS.',
            oldValue: '',
            newValue: ''
          }
        },
        {
          data: {
            date: '14/04/2020 18:42',
            user: 'Gabriela Silveira',
            info: 'Removida pensão CRIANÇAS - 13 A 15 ANOS.',
            oldValue: '',
            newValue: ''
          }
        },
        {
          data: {
            date: '14/04/2020 18:42',
            user: 'Gabriela Silveira',
            info: 'Removida pensão CRIANÇAS - 13 A 15 ANOS.',
            oldValue: '',
            newValue: ''
          }
        },
        {
          data: {
            date: '14/04/2020 18:42',
            user: 'Gabriela Silveira',
            info: 'Removida pensão CRIANÇAS - 13 A 15 ANOS.',
            oldValue: '',
            newValue: ''
          }
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
.pmw-modal {
  &--title {
    z-index: 100;
  }

  &--description {
    b {
      font-weight: font-weight('weight-bold');
    }
  }

  &--datatable {
    z-index: 1;
    ::v-deep {
      .pmw-td {
        justify-content: flex-start !important;
        text-align: left !important;
      }
      .pmw-thead {
        z-index: inherit;
        .pmw-th {
          justify-content: flex-start !important;
          text-align: left !important;
        }
      }
    }
  }
}
</style>
